import { api } from './client';

export const logsAPI = {
  // Получение списка логов с фильтрами
  getLogs: (params = {}) => api.get('/logs/', { params }),

  // Отметка конкретного лога как обработанного
  markReviewed: (id, isReviewed = true) => api.patch(`/logs/${id}/review/`, { is_reviewed: isReviewed }),

  // Пометить сразу все ошибки как обработанные
  markAllReviewed: () => api.patch('/logs/all/review/'),

  // Счетчик непросмотренных ошибок для красного флажка в Header
  getUnreviewedCount: () => api.get('/logs/unreviewed-count/'),
};